import KoobPlaceholder from './KoobPlaceholder';
import cn from '../utils/cn';

type KoobSkeletonProps = {
  /** What loads: a record's page, a form, a list, or a grid of cards. */
  shape: 'details' | 'form' | 'rows' | 'cards';
  /** Rows, fields or cards drawn (the shape's default otherwise). */
  count?: number;
  className?: string;
};

/** The first load of content whose shape is known, in one of four shapes.
 * A one-off shape is drawn with KoobPlaceholder (AGENTS.md, Loading states). */
export default function KoobSkeleton({
  shape,
  count,
  className,
}: KoobSkeletonProps) {
  const body = {
    details: (
      <>
        <KoobPlaceholder className="h-8 w-64 max-w-full rounded" />
        <KoobPlaceholder className="h-48 w-full rounded-lg" />
        <KoobPlaceholder
          count={count ?? 2}
          className="h-24 w-full rounded-lg"
        />
      </>
    ),
    form: [...Array(count ?? 4)].map((_, i) => (
      <div key={i} className="flex flex-col gap-2">
        <KoobPlaceholder className="h-4 w-32 rounded" />
        <KoobPlaceholder className="h-10 w-full rounded" />
      </div>
    )),
    rows: (
      <KoobPlaceholder count={count ?? 5} className="h-12 w-full rounded" />
    ),
    cards: (
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
        <KoobPlaceholder
          count={count ?? 6}
          className="h-[330px] w-full rounded-lg"
        />
      </div>
    ),
  }[shape];

  return (
    <div
      aria-busy="true"
      className={cn('flex w-full flex-col gap-4', className)}
    >
      {body}
    </div>
  );
}
